/* Liquid Ice story pages (BUILD-PAGES, agent PAGES-B, 10.10.2026). Loaded (deferred) from several li-ag-pg-* sections; runs once.
   1 tabs [data-pg-tabs] (vertical nav ≥64rem, underline strip on phones; arrow keys) · 2 coded visuals [data-pg-vis]
   (start state off screen, draw-in on enter, loops only while visible) · 3 chronicle rail [data-pg-chron] fills with scroll
   · 4 one reveal floor for blocks below the fold [data-pg-rv]. No libraries; reduced motion = finished still frames. */
(function () {
  if (window.__liPgB) return; window.__liPgB = 1;
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var IO = 'IntersectionObserver' in window;
  var vh = function () { return window.innerHeight || document.documentElement.clientHeight; };

  /* 1 tabs */
  $$('[data-pg-tabs]').forEach(function (root) {
    var btns = $$('[data-pg-tab]', root), panels = $$('[data-pg-panel]', root);
    function show(i, focus) {
      btns.forEach(function (b, k) { var on = k === i; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
      panels.forEach(function (p, k) { p.hidden = k !== i; });
      if (focus) btns[i].focus();
      var nav = btns[i].parentNode; if (nav.scrollWidth > nav.clientWidth) nav.scrollTo({ left: btns[i].offsetLeft - 24, behavior: RM ? 'auto' : 'smooth' });
      $$('[data-pg-vis]', panels[i]).forEach(enter);
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { show(i); });
      b.addEventListener('keydown', function (e) {
        var k = e.key, n = btns.length, j = -1;
        if (k === 'ArrowRight' || k === 'ArrowDown') j = (i + 1) % n; else if (k === 'ArrowLeft' || k === 'ArrowUp') j = (i - 1 + n) % n; else if (k === 'Home') j = 0; else if (k === 'End') j = n - 1;
        if (j > -1) { e.preventDefault(); show(j, true); }
      });
    });
  });

  /* 2 coded visuals */
  function enter(v) { if (RM) return; v.classList.add('is-in'); v.classList.add('is-live'); }
  var vis = $$('[data-pg-vis]');
  if (!RM && IO) {
    var vo = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { v.classList.add('is-in'); v.classList.add('is-live'); }
        else v.classList.remove('is-live');
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });
    vis.forEach(function (v) {
      var r = v.getBoundingClientRect();
      if (r.top > vh() * 0.88 || r.bottom < 0 || !r.height) v.classList.add('pg-anim');
      vo.observe(v);
    });
  }

  /* 3 chronicle rail: --p = share of the list scrolled past the viewport middle; entries switch on as the rail reaches them */
  var chrons = $$('[data-pg-chron]');
  if (chrons.length) {
    var ticking = false;
    var upd = function () {
      ticking = false;
      chrons.forEach(function (c) {
        var r = c.getBoundingClientRect(), mid = vh() * 0.6;
        var p = RM ? 1 : Math.max(0, Math.min(1, (mid - r.top) / Math.max(1, r.height)));
        c.style.setProperty('--p', p.toFixed(4));
        $$('.pg-chron__li', c).forEach(function (li) { li.classList.toggle('is-on', RM || li.getBoundingClientRect().top < mid); });
      });
    };
    var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } };
    if (!RM) { window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll); }
    upd();
  }

  /* 4 reveal floor */
  if (!RM && IO) {
    var ro = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); ro.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    $$('[data-pg-rv]').forEach(function (el) { if (el.getBoundingClientRect().top > vh()) { el.classList.add('pg-rv'); ro.observe(el); } });
  }
})();
